module.exports = __webpack_public_path__ + "img/sms.560b7174.svg";